module.exports = __webpack_public_path__ + "media/images/ac_templates/201/nppht-ad657e1aa9a7be5c6d397ba7cd21f447.jpg";